import ParameterErrors from '../errors/ParameterErrors';
import Validation from '../validation/Validation';
import DynamicImageFitCriteria from './DynamicImageFitCriteria';
import DynamicImageEntry from './DynamicImageEntry';
import ResizeWatchers from '../ui_core/ResizeWatchers';
import Urls from '../urls/Urls';
import UrlHelper from '../core/UrlHelper';
const{throwNotProvided, throwNotOfType}=ParameterErrors;
export default class DynamicImageDisplayer {
	constructor({dynamicImage, parentElement, resizeWatcherParentElement, className,
	fitWidthElseHeight, allowDowngradeResolution, onClick, resolutionMultiplier, onLoaded,
	configuration}){
		this._configuration = configuration;
		this._allowDowngradeResolution = allowDowngradeResolution===true?true:false;
		this._resolutionMultiplier = resolutionMultiplier===undefined?1:resolutionMultiplier;
		this._dynamicImage = dynamicImage;
		this._parentElement = parentElement;
		this._element = document.createElement('img');
		this._element.classList.add('dynamic-image');
		if(onLoaded)
			this._element.addEventListener('load', onLoaded);
		parentElement.appendChild(this._element);
		if(className)
			this._element.classList.add(className);
		this._onParentElementResize= this._onParentElementResize.bind(this);
		this._fitImageToWidth = this._fitImageToWidth.bind(this);
		this._fitImageToHeight = this._fitImageToHeight.bind(this);
		this._shouldSkipUpdateCosIsDowngrade= this._shouldSkipUpdateCosIsDowngrade.bind(this);
		this._setSrc = this._setSrc.bind(this);
		this._fitImage = fitWidthElseHeight?this._fitImageToWidth:this._fitImageToHeight;
		if(resizeWatcherParentElement)
			this._resizeWatcherParentElement = resizeWatcherParentElement;
		else 
			this._resizeWatcherParentElement = ResizeWatchers.add({element:parentElement, staggered:false});
		this._resizeWatcherParentElement .addEventListener('resized', this._onParentElementResize);
		setTimeout(this._fitImage, 0);
		if(onClick)
			this._element.addEventListener('click', ()=>onClick(dynamicImage));
	}
	_onParentElementResize(e){
		this._fitImage();
	}
	_fitImageToWidth(){
		const newDynamicImageEntry = this._dynamicImage.getBestEntryToFitWidth(this._resolutionMultiplier*this._element.clientWidth);
		const shouldSkip = this._shouldSkipUpdateCosIsDowngrade(newDynamicImageEntry);
		if(shouldSkip)
			return;
		this._currentDynamicImageEntry = newDynamicImageEntry;
		this._setSrc(newDynamicImageEntry);
	}
	_fitImageToHeight(){
		const newDynamicImageEntry = this._dynamicImage.getBestEntryToFitWidth(this._resolutionMultiplier*this._element.clientHeight);
		const shouldSkip = this._shouldSkipUpdateCosIsDowngrade(newDynamicImageEntry);
		if(shouldSkip)
			return;
		this._currentDynamicImageEntry = newDynamicImageEntry;
		this._setSrc(newDynamicImageEntry);
	}
	_shouldSkipUpdateCosIsDowngrade(newDynamicImageEntry){
		if(this._allowDowngradeResolution||!this._currentDynamicImageEntry) 
			return false;
		const isIncrease = (
				(newDynamicImageEntry.width>this._currentDynamicImageEntry.width)
				||
				(newDynamicImageEntry.height>this._currentDynamicImageEntry.height)
			);
		return !isIncrease;
	}
	_setSrc(dynamicImageEntry){
		this._element.src = `${Urls.getAssetsForSite(this._configuration.siteSlug)}${UrlHelper.removeStartSlash(dynamicImageEntry.relativePath)}`;
	}
	get element(){
		return this._element;
	}
}